var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-1444.263 -247.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-close-circle-outline",
    "data-name": "Icon ionic-md-close-circle-outline",
    transform: "translate(1440.888 243.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M15.375,5.8A9.573,9.573,0,1,1,8.6,8.6a9.537,9.537,0,0,1,6.773-2.8m0-2.423a12,12,0,1,0,12,12,12,12,0,0,0-12-12Z",
    fill: "#121b45"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M22.049,20.46l-1.59,1.59-4.091-4.091-4.091,4.091-1.59-1.59,4.091-4.091-4.091-4.091,1.59-1.59,4.091,4.091,4.091-4.091,1.59,1.59-4.091,4.091Z",
    transform: "translate(1439.895 242.645)",
    fill: "#121b45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupClose);
export default __webpack_public_path__ + "static/media/popup-close.a6c6ec635d6181bcf4e22d1ff816f71d.svg";
export { ForwardRef as ReactComponent };